import { DotLegalButton } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../localization/useTranslation";
import { AddTaskRelationData } from "../../createTaskPane/CreateTaskPane.types";
import { usePanes } from "../../../main/panes/usePanes";
import CreateTaskPane from "../../createTaskPane/CreateTaskPane";

export interface IAddTaskButton {
    relationInformation?: AddTaskRelationData;
    size?: "small" | "medium" | "large";
}

function AddTaskButton(props: IAddTaskButton) {
    const { translateString } = useTranslation();
    const { open } = usePanes();

    return (
        <DotLegalButton buttonType={"primary"} size={props.size} onClick={() => open(CreateTaskPane, { relationInformation: props.relationInformation })}>
            {translateString("createTask")}
        </DotLegalButton>
    );
}

export default AddTaskButton;
